document.documentElement.classList.add('qe-js');
(function () {
  'use strict';

  var instances = new Map();
  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var supportsSDT = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');

  function clamp(v, min, max) { return v < min ? min : v > max ? max : v; }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function setScrollbarWidth() {
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--qe-sbw', (sbw > 0 && sbw < 40 ? sbw : 0) + 'px');
  }

  function init(root) {
    if (!root || instances.has(root)) return;
    var cleanups = [];
    var motion = !reduceQuery.matches;
    var formEl = root.querySelector('[data-qe-form]') || root.querySelector('form.qe-form');
    var idSelect = root.querySelector('[data-qe-id]');
    var variants = [];
    try {
      var data = root.querySelector('[data-qe-variants]');
      variants = data ? JSON.parse(data.textContent) : [];
    } catch (e) { variants = []; }

    var labels = {
      add: root.getAttribute('data-label-add') || 'Add to bag',
      soldout: root.getAttribute('data-label-soldout') || 'Sold out',
      unavailable: root.getAttribute('data-label-unavailable') || 'Unavailable',
      error: root.getAttribute('data-error-generic') || 'Something went wrong. Please try again.'
    };

    function on(el, type, fn, opts) {
      if (!el) return;
      el.addEventListener(type, fn, opts);
      cleanups.push(function () { el.removeEventListener(type, fn, opts); });
    }

    if (motion) root.classList.add('qe-motion');
    if (supportsSDT) root.classList.add('qe-sdt');

    /* Gallery */
    var track = root.querySelector('[data-qe-track]');
    var thumbs = qsa(root, '[data-qe-thumbs] .qe-thumb');
    var countEl = root.querySelector('[data-qe-count]');
    var slides = track ? qsa(track, '.qe-gallery__slide') : [];

    function setActiveSlide(index) {
      thumbs.forEach(function (t, i) {
        var active = i === index;
        t.classList.toggle('is-active', active);
        if (active) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (countEl) countEl.textContent = String(index + 1);
    }

    function goToSlide(index, instant) {
      if (!track || !slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: instant || !motion ? 'auto' : 'smooth' });
      setActiveSlide(index);
    }

    function goToMedia(mediaId, instant) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goToSlide(i, instant); return; }
      }
    }

    thumbs.forEach(function (t, i) { on(t, 'click', function () { goToSlide(i); }); });

    if (track && slides.length > 1) {
      var galleryTick = false;
      on(track, 'scroll', function () {
        if (galleryTick) return;
        galleryTick = true;
        requestAnimationFrame(function () {
          galleryTick = false;
          var w = track.clientWidth || 1;
          setActiveSlide(clamp(Math.round(track.scrollLeft / w), 0, slides.length - 1));
        });
      }, { passive: true });
      on(track, 'keydown', function (e) {
        var w = track.clientWidth || 1;
        var cur = Math.round(track.scrollLeft / w);
        if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(clamp(cur + 1, 0, slides.length - 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(clamp(cur - 1, 0, slides.length - 1)); }
      });
    }

    /* Variants */
    var optionGroups = qsa(root, '[data-qe-option]');

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var checked = group.querySelector('input[data-qe-option-input]:checked');
        if (checked) return checked.value;
        var sel = group.querySelector('select[data-qe-option-input]');
        return sel ? sel.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { match = false; break; } }
        if (match) return v;
      }
      return null;
    }

    function setOptionValues(v) {
      optionGroups.forEach(function (group, idx) {
        var val = v.options[idx];
        qsa(group, 'input[data-qe-option-input]').forEach(function (input) { input.checked = input.value === val; });
        var sel = group.querySelector('select[data-qe-option-input]');
        if (sel) sel.value = val;
      });
    }

    function markAvailability(opts) {
      optionGroups.forEach(function (group, idx) {
        var valueLabel = group.querySelector('[data-qe-option-value]');
        if (valueLabel) valueLabel.textContent = opts[idx] || '';
        qsa(group, 'input[data-qe-option-input]').forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var candidate = variants.filter(function (v) {
            for (var j = 0; j < test.length; j++) { if (j <= idx && v.options[j] !== test[j]) return false; }
            return true;
          });
          var available = candidate.some(function (v) { return v.available; });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function setText(sel, text) {
      qsa(root, sel).forEach(function (el) { el.textContent = text; });
    }

    function renderVariant(v) {
      var atcButtons = qsa(root, '[data-qe-atc], [data-qe-proxy-atc]');
      if (!v) {
        atcButtons.forEach(function (b) { b.disabled = true; });
        setText('[data-qe-atc-label]', labels.unavailable);
        return;
      }
      if (idSelect) {
        idSelect.value = String(v.id);
        idSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setText('[data-qe-price-now]', v.price);
      setText('[data-qe-price-was-value]', v.was || '');
      qsa(root, '[data-qe-price-was]').forEach(function (el) { el.hidden = !v.was; });
      setText('[data-qe-price-save-value]', v.save || '');
      qsa(root, '[data-qe-price-save]').forEach(function (el) { el.hidden = !v.save; });
      atcButtons.forEach(function (b) { b.disabled = !v.available; });
      setText('[data-qe-atc-label]', v.available ? labels.add : labels.soldout);
      if (v.media) goToMedia(v.media);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    function onOptionChange(e) {
      var group = e.target.closest('[data-qe-option]');
      var changedIdx = group ? optionGroups.indexOf(group) : -1;
      var opts = selectedOptions();
      var v = findVariant(opts);
      if (!v || !v.available) {
        var fallback = variants.filter(function (x) { return changedIdx < 0 || x.options[changedIdx] === opts[changedIdx]; });
        var best = fallback.filter(function (x) { return x.available; })[0] || (!v ? fallback[0] : null);
        if (best && best !== v) { v = best; setOptionValues(v); opts = v.options.slice(); }
      }
      markAvailability(opts);
      renderVariant(v);
      hideError();
    }

    optionGroups.forEach(function (group) { on(group, 'change', onOptionChange); });
    if (optionGroups.length) markAvailability(selectedOptions());

    /* Quantity */
    qsa(root, '[data-qe-qty]').forEach(function (btn) {
      on(btn, 'click', function () {
        var box = btn.closest('.qe-qty');
        var qtyInput = box && box.querySelector('[data-qe-qty-input]');
        if (!qtyInput || qtyInput.disabled) return;
        var step = parseInt(btn.getAttribute('data-qe-qty'), 10) || 0;
        var min = parseInt(qtyInput.min, 10) || 1;
        var max = parseInt(qtyInput.max, 10) || 99;
        qtyInput.value = clamp((parseInt(qtyInput.value, 10) || min) + step, min, max);
      });
    });
    qsa(root, '[data-qe-qty-input]').forEach(function (qtyInput) {
      on(qtyInput, 'change', function () {
        var min = parseInt(qtyInput.min, 10) || 1;
        var max = parseInt(qtyInput.max, 10) || 99;
        qtyInput.value = clamp(parseInt(qtyInput.value, 10) || min, min, max);
      });
    });

    /* Add to cart */
    var errorEl = root.querySelector('[data-qe-error]');
    var atcMain = root.querySelector('[data-qe-atc]');
    var addUrl = (root.getAttribute('data-cart-add-url') || '/cart/add').replace(/\/$/, '') + '.js';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var busy = false;

    var proxyErrors = qsa(root, '[data-qe-error-proxy]');
    var lastSource = null; /* the buy button that started this add, so the error shows next to it */
    function showError(msg) {
      var unit = lastSource && lastSource.closest('[data-qe-buy-unit]');
      var own = unit ? qsa(unit, '[data-qe-error-proxy]') : [];
      (own.length ? own : proxyErrors).forEach(function (el) { el.textContent = msg; el.hidden = false; });
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function hideError() {
      proxyErrors.forEach(function (el) { el.hidden = true; el.textContent = ''; });
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    }
    function setBusy(state) {
      busy = state;
      qsa(root, '[data-qe-atc], [data-qe-proxy-atc]').forEach(function (b) {
        b.classList.toggle('is-loading', state);
        if (state) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
    }

    on(formEl, 'submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (e.submitter && e.submitter.hasAttribute('data-qe-proxy-atc')) lastSource = e.submitter;
      if (busy || (atcMain && atcMain.disabled)) return;
      hideError();
      setBusy(true);
      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(formEl)
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) { return { ok: res.ok, body: body }; });
      }).then(function (r) {
        if (!r.ok) {
          var msg = (r.body && (r.body.description || r.body.message)) || labels.error;
          if (typeof msg !== 'string') msg = labels.error;
          showError(msg);
          setBusy(false);
          return;
        }
        window.location.href = cartUrl;
      }).catch(function () {
        showError(labels.error);
        setBusy(false);
      });
    });

    qsa(root, '[data-qe-proxy-atc]').forEach(function (btn) {
      on(btn, 'click', function () {
        if (!formEl || btn.disabled) return;
        lastSource = btn;
        if (btn.type === 'submit') return; /* a real submit button already submits the form */
        if (errorEl && root.querySelector('[data-qe-sticky]')) {
          errorEl.setAttribute('data-from-proxy', 'true');
        }
        if (formEl.requestSubmit) formEl.requestSubmit(); else formEl.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    });

    /* Error from a proxy button: bring it into view */
    if (errorEl && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (!errorEl.hidden && errorEl.getAttribute('data-from-proxy') === 'true') {
          errorEl.removeAttribute('data-from-proxy');
          errorEl.scrollIntoView({ behavior: motion ? 'smooth' : 'auto', block: 'center' });
        }
      });
      mo.observe(errorEl, { attributes: true, attributeFilter: ['hidden'] });
      cleanups.push(function () { mo.disconnect(); });
    }

    /* Sticky bar */
    var sticky = root.querySelector('[data-qe-sticky]');
    var finalSection = root.querySelector('[data-qe-final]');
    if (sticky && atcMain && 'IntersectionObserver' in window) {
      var pastBuy = false;
      var finalVisible = false;
      var unitsOnScreen = 0;
      var updateSticky = function () {
        var show = pastBuy && !finalVisible && unitsOnScreen === 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      };
      var ioBuy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { pastBuy = !en.isIntersecting && en.boundingClientRect.top < 0; });
        updateSticky();
      });
      if (atcMain.getClientRects().length) ioBuy.observe(atcMain);
      else { pastBuy = true; updateSticky(); } /* buy box hidden: the sticky bar is the buy button */
      cleanups.push(function () { ioBuy.disconnect(); });
      if (finalSection) {
        var ioFinal = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { finalVisible = en.isIntersecting; });
          updateSticky();
        }, { rootMargin: '0px 0px -30% 0px' });
        ioFinal.observe(finalSection);
        cleanups.push(function () { ioFinal.disconnect(); });
      }
      var bands = qsa(root, '[data-qe-cta]');
      if (bands.length) {
        var seen = new Set();
        var ioBands = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
          unitsOnScreen = seen.size;
          updateSticky();
        }, { rootMargin: '0px' });
        bands.forEach(function (b) { ioBands.observe(b); });
        cleanups.push(function () { ioBands.disconnect(); });
      }
    }

    /* Reel */
    var reel = root.querySelector('[data-qe-reel-track]');
    var prev = root.querySelector('[data-qe-reel-prev]');
    var next = root.querySelector('[data-qe-reel-next]');
    if (reel) {
      var reelStep = function (dir) {
        var item = reel.querySelector('.qe-reel__item');
        var gap = parseFloat(getComputedStyle(reel).columnGap) || 16;
        var w = item ? item.getBoundingClientRect().width + gap : reel.clientWidth * 0.8;
        reel.scrollBy({ left: dir * w, behavior: motion ? 'smooth' : 'auto' });
      };
      var reelUpdate = function () {
        var maxScroll = reel.scrollWidth - reel.clientWidth - 2;
        if (prev) prev.disabled = reel.scrollLeft <= 2;
        if (next) next.disabled = reel.scrollLeft >= maxScroll;
      };
      on(prev, 'click', function () { reelStep(-1); });
      on(next, 'click', function () { reelStep(1); });
      var reelTick = false;
      on(reel, 'scroll', function () { if (reelTick) return; reelTick = true; requestAnimationFrame(function () { reelTick = false; reelUpdate(); }); }, { passive: true });
      reelUpdate();
    }

    /* Scroll-driven progress */
    var progressEls = qsa(root, '[data-qe-progress]').filter(function (el) {
      return !(supportsSDT && el.getAttribute('data-qe-progress') === 'view');
    });
    var chapterLines = qsa(root, '[data-qe-line]');

    /* One rAF loop. Geometry is measured once (load, resize, content size changes), so a scroll frame
       reads only scrollY and never forces layout. Progress eases toward its target, so a fast fling
       glides instead of jumping; off-screen elements snap. */
    var geo = [];          /* {el, top, h, pin, p} per progress element, document coordinates */
    var lineGeo = [];      /* {el, mid} per chapter line */
    var vh = window.innerHeight || 1;
    var vw = window.innerWidth || 1;
    var lastActiveLine = -1;
    var rafId = 0;
    var lastT = 0;
    var geoDirty = true;

    function docTop(el) { return el.getBoundingClientRect().top + (window.pageYOffset || 0); }
    function measureGeo() {
      geoDirty = false;
      vh = window.innerHeight || 1;
      vw = window.innerWidth || 1;
      geo = progressEls.map(function (el, i) {
        var old = geo[i];
        return { el: el, top: docTop(el), h: el.offsetHeight, pin: el.getAttribute('data-qe-progress') === 'pin', p: old ? old.p : undefined };
      });
      lineGeo = chapterLines.map(function (line) { return { el: line, mid: docTop(line) + line.offsetHeight / 2, h: line.offsetHeight }; });
    }
    function targetFor(g, y) {
      var rTop = g.top - y;
      var p;
      if (g.pin) {
        var total = g.h - vh;
        p = total > 0 ? -rTop / total : (rTop < 0 ? 1 : 0);
      } else {
        p = (vh - rTop) / (vh + g.h);
      }
      return clamp(p, 0, 1);
    }
    function frame(t) {
      rafId = 0;
      if (geoDirty) measureGeo();
      var dt = lastT ? Math.min(64, t - lastT) : 16.7;
      lastT = t;
      var k = 1 - Math.pow(0.72, dt / 16.7); /* ~28% of the remaining distance per 60 Hz frame */
      var y = window.pageYOffset || 0;
      var moving = false;
      for (var i = 0; i < geo.length; i++) {
        var g = geo[i];
        var near = g.top - y < vh * 1.2 && g.top + g.h - y > -vh * 0.2;
        var target = targetFor(g, y);
        var p;
        if (g.p === undefined || !near) p = target;             /* first frame or off-screen: snap */
        else {
          p = g.p + (target - g.p) * k;
          if (Math.abs(target - p) < 0.0008) p = target; else moving = true;
        }
        if (g.p === undefined || Math.abs(g.p - p) > 0.0002) {
          g.p = p;
          if (near || g.el._qeP !== p) { g.el._qeP = p; g.el.style.setProperty('--p', p.toFixed(4)); }
        }
      }
      if (lineGeo.length) {
        var target = y + vh * (vw < 990 ? 0.74 : 0.5);
        var best = -1;
        var bestDist = Infinity;
        for (var j = 0; j < lineGeo.length; j++) {
          var L = lineGeo[j];
          if (L.mid + L.h / 2 < y || L.mid - L.h / 2 > y + vh) continue;
          var d = Math.abs(L.mid - target);
          if (d < bestDist) { bestDist = d; best = j; }
        }
        if (best !== lastActiveLine) {
          lastActiveLine = best;
          lineGeo.forEach(function (L, i2) { L.el.classList.toggle('is-active', i2 === best); });
        }
      }
      if (moving) rafId = requestAnimationFrame(frame); else lastT = 0;
    }
    function requestTick() { if (!rafId) rafId = requestAnimationFrame(frame); }
    function invalidate() { geoDirty = true; requestTick(); }

    if (motion) {
      on(window, 'scroll', requestTick, { passive: true });
      on(window, 'resize', invalidate, { passive: true });
      on(window, 'load', invalidate);
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(invalidate); /* images, fonts or app widgets changing the page height */
        ro.observe(document.body);
        progressEls.forEach(function (el) { ro.observe(el); });
        cleanups.push(function () { ro.disconnect(); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(invalidate);
      cleanups.push(function () { if (rafId) cancelAnimationFrame(rafId); rafId = 0; });
      requestTick();
    }

    /* Decode images before a fast fling reaches them (lazy images start loading ~1.5 screens ahead) */
    if ('IntersectionObserver' in window) {
      var ioDecode = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var img = en.target;
          ioDecode.unobserve(img);
          if (img.loading === 'lazy') img.loading = 'eager';
          if (img.decode) img.decode().catch(function () {});
        });
      }, { rootMargin: '150% 0px 150% 0px' });
      qsa(root, 'img[loading="lazy"]').forEach(function (img) { ioDecode.observe(img); });
      cleanups.push(function () { ioDecode.disconnect(); });
    }

    /* Reveals, bars, counters */
    var reveals = qsa(root, '[data-qe-reveal], [data-qe-bars]');
    var counters = qsa(root, '[data-qe-count-to]');

    function runCounter(el) {
      var raw = el.getAttribute('data-qe-count-to') || '';
      var target = parseFloat(raw.replace(',', '.'));
      if (isNaN(target)) { el.textContent = raw; return; }
      var decimals = (raw.split(/[.,]/)[1] || '').length;
      var start = null;
      var dur = 1600;
      function frame(ts) {
        if (start === null) start = ts;
        var t = clamp((ts - start) / dur, 0, 1);
        var eased = t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
        el.textContent = (target * eased).toFixed(decimals);
        if (t < 1) requestAnimationFrame(frame); else el.textContent = raw;
      }
      requestAnimationFrame(frame);
    }

    if (motion && 'IntersectionObserver' in window) {
      var ioReveal = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); ioReveal.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
      reveals.forEach(function (el) { ioReveal.observe(el); });
      cleanups.push(function () { ioReveal.disconnect(); });

      var ioCount = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { runCounter(en.target); ioCount.unobserve(en.target); }
        });
      }, { threshold: 0.6 });
      counters.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top > window.innerHeight) {
          var raw = el.getAttribute('data-qe-count-to') || '';
          if (!isNaN(parseFloat(raw))) el.textContent = '0';
          ioCount.observe(el);
        }
      });
      cleanups.push(function () { ioCount.disconnect(); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    instances.set(root, function () {
      cleanups.forEach(function (fn) { fn(); });
      root.classList.remove('qe-motion', 'qe-sdt');
    });
  }

  function destroy(root) {
    var fn = instances.get(root);
    if (fn) { fn(); instances.delete(root); }
  }

  function boot(scope) {
    setScrollbarWidth();
    qsa(scope || document, '[data-qe-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  window.addEventListener('load', setScrollbarWidth);
  window.addEventListener('resize', setScrollbarWidth);

  reduceQuery.addEventListener && reduceQuery.addEventListener('change', function () {
    Array.from(instances.keys()).forEach(function (root) { destroy(root); init(root); });
  });

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    qsa(e.target, '[data-qe-root]').forEach(destroy);
  });
})();
